<!-- Tabla úlitmas transacciones de eventos de organizador (Se usa en la vista src/views/admin/Home.vue)-->
<!-- El componente obtiene los datos de las últimas transacciones de eventos con consultas directas con express y mongoose
     *.- Al iniciar el componente solo se obtiene la lista de eventos
     *.- El usuario debe de selecciona alguno y al dar click en el botón de "buscar", se realizará una consulta de ese evento
            (La consulta traera como máximo 400 transacciones, si el evento tiene más transaciones se habilitará un botón 
            para traer más transacciones por bloques de 400)
     *.- Si al dar click al boton de traer más transacciones ya no hay más registros, este se desactivará automáticamente-->
<template>
  <v-row justify="center" class="elevation-2 pa-5">
    <v-col cols="12">
      <v-row justify="center" align="center">
        <v-col cols="6" sm="7" md="8" lg="9">
          <span class="headline font-weight-bold mr-5">Últimas transacciones (Eventos)</span>
          <v-btn color="accent" class="black--text font-weight-bold" @click="downloadCsv(transactions)">
            Reporte<v-icon right>mdi-download</v-icon>
          </v-btn>
        </v-col>

        <!-- BOTÓN PARA DESCARGAR UN REPORTE EN EXCEL -->
        <v-col cols="6" sm="5" md="4" lg="3">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
            class="mr-0 mr-md-5"
          ></v-text-field>
  <!--
          <v-row justify="end" class="mr-5">
            <v-btn color="accent" class="black--text font-weight-bold" @click="downloadCsv(transactions)">
              Reporte<v-icon right>mdi-download</v-icon>
            </v-btn>
            
            <v-icon
              v-bind:style="getSize"
              class="excel-icon pointer"
              @click="downloadCsv(transactions)"
            >fas fa-file-excel</v-icon>
          </v-row>-->
        </v-col>
        <v-col cols="10" sm="5" md="4">
          <v-select
            :loading="loadingEventSelector"
            v-model="eventValue"
            :items="items"
            label="Selecciona un evento"
            @change="loadingEventOrders = false"
          >
          </v-select>
        </v-col>
        <v-col cols="2" sm="7" md="8">
          <v-btn color="primary" fab small @click="pageNumber=1, formatOrders()" :loading="loadingEventOrders" :disabled="eventValue==''">
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-divider></v-divider>

      <!-- CONTENIDO DE LA TABLA -->
      <v-data-table
        no-data-text="No hay datos disponibles."
        no-results-text="No hay datos disponibles."
        loading-text="Cargando datos..."
        class="table-header"
        :search="search"
        :calculate-widths="true"
        :headers="transactionsHeaders"
        :items="transactions"
        :items-per-page="($vuetify.breakpoint.xsOnly)?3:10"
        :loading="loading"
        :header-props="{
          sortByText:'Ordenar por'
        }"
        :footer-props="{
          itemsPerPageText: 'Filas por página',
          itemsPerPageAllText:'Todas',
        }"
      >
        <template v-slot:body="{items}">
          <tbody>
            <tr
              v-for="(item, index) in items"
              :key="index"
              class="text-center"
              :class="[($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-table-row':'' ]"
            >
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                >{{transactionsHeaders[0].text}}</div>
                <div
                  :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                >{{item.event}}</div>
              </td>
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                >{{transactionsHeaders[1].text}}</div>
                <div
                  :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                >{{item.assistant}}</div>
              </td>
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                >{{transactionsHeaders[2].text}}</div>
                <div
                  :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                >{{item.company || 'N/D' }}</div>
              </td>
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                >{{transactionsHeaders[3].text}}</div>
                <div
                  :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                >{{ item.email || 'N/D'}}</div>
              </td>
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                >{{transactionsHeaders[4].text}}</div>
                <div
                  :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                >{{item.paymentMethod}}</div>
              </td>
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                >{{transactionsHeaders[5].text}}</div>
                <div :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''">
                  <v-chip
                    :color="(item.status=='Completado')?'success':'secondary'"
                    dark
                  >{{ item.status }}</v-chip>
                </div>
              </td>
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                >{{transactionsHeaders[6].text}}</div>
                <div
                  :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                >${{ item.total | currency}}</div>
              </td>
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                >{{transactionsHeaders[7].text}}</div>
                <div
                  :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                >
                <v-chip
                    v-if="item.bill && item.bill.email"
                    :color="item.bill.facturapiFolio?'accent':'secondary'"
                    @click.native.stop="showDataBill(item.bill)"
                    dark
                  >
                    <v-icon small>fas fa-check</v-icon>
                  </v-chip>
                <v-chip
                    v-else
                    color='grey lighten-1'
                    dark
                  >
                    <v-icon small>fas fa-times</v-icon>
                  </v-chip>
                </div>
              </td>
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                >{{transactionsHeaders[8].text}}</div>
                <div
                  :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                >{{ item.date }}</div>
              </td>
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                >{{transactionsHeaders[9].text}}</div>
                <div
                  :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                >{{ item.hour }}</div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
      <v-row v-if="orders.length >=400 && eventValue == eventValueOld && eventValue!=''" justify="end" class="mt-5">
        <v-btn class="primary" @click="fetchMoreOrders()" :loading="loadingMoreOrders" :disabled="disabledOrdersButton">
          Cargar más transacciones ...
        </v-btn>
      </v-row>
      <!-- DIALOG PARA VER INFORMACIÓN DE FACTURACIÓN -->
      <v-dialog v-if="billingDialog" v-model="billingDialog" persistent width="500" overlay-opacity="0.2">
        <v-card>
          <v-card-title class="headline font-weight-bold text-center">Información de facturación</v-card-title>
          <v-divider class="pt-3"></v-divider>
          <div class="mx-5">  
            <p><strong>Razón social/Nombre fiscal:</strong> {{billingData.razonSocialONombreFiscal}}</p>
            <p><strong>RFC:</strong> {{billingData.rfc}}</p>
            <p v-if="billingData.address"><strong>Dirección:</strong> {{billingData.address}}</p>
            <p v-if="billingData.zipCode"><strong>Código postal:</strong> {{billingData.zipCode}}</p>
            <p><strong>CFDI:</strong> {{billingData.usoDelCfdi}}</p>
            <p><strong>Forma de pago:</strong> {{billingData.formaDePago}}</p>
            <p><strong>Método de pago:</strong> {{billingData.metodoDePago}}</p>
            <p><strong>E-mail:</strong> {{billingData.email}}</p>
            <p v-if="billingData.facturapiFolio"><strong>Folio de factura:</strong> {{billingData.facturapiFolio}}</p>
            <p v-if="billingData.facturapiFolioFiscal"><strong>Folio fiscal:</strong> {{billingData.facturapiFolioFiscal}}</p>
          </div>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="billingDialog = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { async } from "q";
export default {
  data() {
    return {
      loading: true,
      loadingEventOrders: false,
      loadingMoreOrders: false,
      hideOrdersButton: true,
      transactionsHeaders: [
        { align: "center", text: "Evento", value: "event" },
        { align: "center", text: "Titular", value: "assistant" },
        { align: "center", text: "Empresa/Institución", value: "company" },
        { align: "center", text: "Email", value: "email" },
        { align: "center", text: "Método de pago", value: "paymentMethod" },
        {
          align: "center",
          text: "Estatus del pago",
          width: "150px",
          value: "status"
        },
        { align: "center", text: "Total", value: "total" },
        { align: "center", text: "Factura", value: "bill" },
        { align: "center", text: "Fecha de pago", value: "date" },
        { align: "center", text: "Hora", width: "90px", value: "hour" }
      ],
      transactions: [],
      billingDialog: false,
      billingData: {},
      search: "",
      items: [],
      eventValue: "",
      eventValueOld: "",
      loadingEventSelector: true,
      pageNumber: 1,
      allQtyOrdersOld: 0,
      allQtyOrdersNew: 0,
      disabledOrdersButton: false
    };
  },
  computed: {
    ...mapState("order", ["orders"]),
    ...mapState("event", ["organizationEventList"]),
    getSize() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "font-size:1.8em";
        case "sm":
          return "font-size:1.8em";
        case "md":
          return "font-size:1.5em";
        case "lg":
          return "font-size:1.6em";
        case "xl":
          return "font-size:1.7em";
      }
    }
  },
  methods: {
    ...mapActions("order", ["fetchOrdersInformation", "fetchOrdersPerEventApi"]),
    ...mapActions("event", ["fetchOrganizerEventListApi"]),
    ...mapMutations("user", ["logout"]),
    ...mapMutations("notifications", ["show"]),
    /**
     * Función para descargar el reporte de las ordenes.
     * @param {Array<Object>} orders Arreglo de transacciones de un evento en específico.
     */
    downloadCsv(orders) {
      const header = [
        "orderId",
        "Evento",
        "Asistente",
        "Empresa_Institucion",
        "Telefono",
        "Metodo_de_pago",
        "Email",
        "Estatus",
        "Total",
        "Dia",
        "Hora",
        "Factura",
        "RazonSocial_NombreFiscal",
        "Rfc",
        "Cfdi",
        "FormaDePago",
        "MetodoDePago",
        "EmailFactura",
        "FolioFactura",
        "FolioFiscal",
      ];
      // Llenar el arreglo de items con transacciones de eventos, para esto se aplican algunos formatos
      let items = [];
      orders.forEach(order => {
        let currentOrder = {};
        currentOrder.orderId = order.orderId;
        currentOrder.Evento = order.event;
        currentOrder.Asistente = order.assistant;
        currentOrder.Empresa_Institucion = order.company;
        if (order.company != "") {
          currentOrder.Empresa_Institucion = order.company;
        } else {
          currentOrder.Empresa_Institucion = "N/D"
        }
        if (order.phone != "") {
          currentOrder.Telefono = order.phone;
        } else {
          currentOrder.Telefono = "N/D";
        }
        currentOrder.Metodo_de_pago = order.paymentMethod;
        currentOrder.Email = order.email;
        currentOrder.Estatus = order.status;
        currentOrder.Total = order.total;
        currentOrder.Dia = order.date;
        currentOrder.Hora = order.hour;
        if (order.bill && order.bill.email) {
          currentOrder.Factura = "Si";
          currentOrder.RazonSocial_NombreFiscal = order.bill.razonSocialONombreFiscal
          currentOrder.Rfc = order.bill.rfc
          currentOrder.Cfdi = order.bill.usoDelCfdi
          currentOrder.FormaDePago = order.bill.formaDePago
          currentOrder.MetodoDePago = order.bill.metodoDePago
          currentOrder.EmailFactura = order.bill.email
          currentOrder.FolioFactura = order.bill.facturapiFolio?order.bill.facturapiFolio:'';
          currentOrder.FolioFiscal = order.bill.facturapiFolioFiscal?order.bill.facturapiFolioFiscal:'';
        } else {
          currentOrder.Factura = "No";
        }
        items.push(currentOrder);
      });

      const replacer = (key, value) => (value === null ? "" : value); // specify how you want to handle null values here
      let csv = items.map(row =>
        header
          .map(fieldName => JSON.stringify(row[fieldName]), replacer)
          .join(",")
      );
      csv.unshift(header.join(","));
      csv = csv.join("\r\n");
      var link = window.document.createElement("a");
      link.setAttribute(
        "href",
        "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csv)
      );
      link.setAttribute("download", "Ultimas_transacciones.csv");
      link.click();
    },

    /**
     * Función modifica el estado de las ordenes a una forma amigable al usuario.
     * @param { string } estatus El estado actual de una transacción.
     */
    formatEstatus(estatus) {
      if (estatus == "IN_PROGRESS") {
        return "En progreso";
      } else {
        return "Completado";
      }
    },
    /**
     * Función modifica el método de pago de las ordenes a una forma amigable al usuario.
     * @param {string} paymentMethod El método de pago utilizado para la transacción.
     */
    formatPaymentMethod(paymentMethod) {
      let newPaymentMehtod = "";
      switch (paymentMethod) {
        case "CASH":
          newPaymentMehtod = "Efectivo";
          break;
        case "BANK_TRANSFER":
          newPaymentMehtod = "SPEI";
          break;
        case "CARD":
          newPaymentMehtod = "Tarjeta";
          break;
        case "PAYPAL":
          newPaymentMehtod = "PayPal";
          break;
        case "FREE":
          newPaymentMehtod = "Gratis";
          break;
        default:
          newPaymentMehtod = "N/D";
          break;
      }
      return newPaymentMehtod;
    },
    /**
     * Función que obtiene la fecha de la transacción con el siguiente formato DD/MM/YYYY
     * @param {Date} date Valor de la fecha.
     */
    formatDate(date) {
      let newDate = new Date(date);
      return `${newDate.getDate()}/${newDate.getMonth()+1}/${newDate.getFullYear()}`
    },
    /**
     * Función que obtiene la hora de la transacción con el siguiente formato HH:MM A.M./P.M.
     * @param {Date} date Valor de la fecha.
     */
    formatHour(date) {
      let time = new Date(date);
      var hour = time.getHours();
      var minute = time.getMinutes();
      //var second = time.getSeconds();
      var temp = '' + ((hour > 12) ? hour - 12 : hour);
      if (hour == 0)
        temp = '12';
      temp += ((minute < 10) ? ':0' : ':') + minute;
      //temp += ((second < 10) ? ':0' : ':') + second;
      temp += (hour >= 12) ? ' P.M.' : ' A.M.';
      return temp;
    },
    async formatOrders2() {
      await this.fetchOrdersInformation();
      this.transactions = this.orders.map(order => {
        return {
          orderId: order._id,
          event: order.eventInformation.name,
          assistant: `${order.paymentInformation.name} ${order.paymentInformation.lastName}`,
          company: order.attendeeInformation[0]?order.attendeeInformation[0].companyName:'',
          phone: order.attendeeInformation[0]?order.attendeeInformation[0].tel:'',
          paymentMethod: this.formatPaymentMethod(
            order.paymentInformation.paymentType
          ),
          email: order.paymentInformation.email,
          status: this.formatEstatus(order.orderStatus),
          total: order.total > 0 ? order.total : "0",
          bill: order.billingInformation,
          date: order.createdAt.substring(0,10)
        };
      });

      this.transactions = this.transactions.filter(
        transaction =>
          !(
            transaction.paymentMethod == "Tarjeta" &&
            transaction.status == "En progreso"
          )
      );
    },

    /**
     * Función para dar formato al objeto de la base de datos para su uso en la data table.
     */
    async formatOrders() {
      if (this.pageNumber == 1) {
        this.loadingEventOrders = true;
        this.disabledOrdersButton = false;
      }
      // Traer bloques de 400 transacciones
      await this.fetchOrdersPerEventApi({eventId:this.eventValue, recordsQuantity:400, pageNumber: this.pageNumber});
      //console.log(this.orders);
      this.transactions = this.orders.map(order => {
        return {
          orderId: order._id,
          event: order.eventInformation.name,
          assistant: `${order.paymentInformation.name} ${order.paymentInformation.lastName}`,
          company: order.attendeeInformation[0]?order.attendeeInformation[0].companyName:'',
          phone: order.attendeeInformation[0]?order.attendeeInformation[0].tel:'',
          paymentMethod: this.formatPaymentMethod(
            order.paymentInformation.paymentType
          ),
          email: order.paymentInformation.email,
          status: this.formatEstatus(order.orderStatus),
          total: order.total > 0 ? order.total : "0",
          bill: order.billingInformation,
          //date: order.createdAt.substring(0,10)
          //date: new Date(order.updatedAt).toLocaleDateString("es-MX")
          date: this.formatDate(order.updatedAt),
          hour: this.formatHour(order.updatedAt),
        };
      });

      this.transactions = this.transactions.filter(
        transaction =>
          !(
            transaction.paymentMethod == "Tarjeta" &&
            transaction.status == "En progreso"
          )
      );
      this.eventValueOld = this.eventValue;
      if (this.pageNumber == 1) {
        this.loadingEventOrders = false;
      }
    },
    /**
     * Si el evento tiene más de 400 transacciones esta función ayuda a traer más transacciones
     */
    async fetchMoreOrders() {
      try {
        this.loadingMoreOrders = true;
        this.allQtyOrdersOld = this.transactions.length;
        this.pageNumber++;
        await this.formatOrders();
        this.allQtyOrdersNew = this.transactions.length;
        if (this.allQtyOrdersNew == this.allQtyOrdersOld) {
          this.disabledOrdersButton = true;
        }
        this.loadingMoreOrders = false;
      } catch (error) {
        console.error(error);
        this.loadingMoreOrders = false;
      }
    },
    showDataBill(billingData) {
      this.billingDialog = true;
      this.billingData = billingData;
    },
    formatEventList() {
      this.organizationEventList.forEach( event => {
        this.items.push({text: event.name, value: event._id});
      });
      this.loadingEventSelector = false;
    }
  },
  async mounted() {
    // Vaidar que el usuario tiene su sesión iniciada
    let res = await this.fetchOrganizerEventListApi();
    if (res.message == 'Autenticacion requerida ' || res.message == 'jwt expired' || res.message == 'invalid signature') {
      this.logout();
      this.show({ text: "La sesión ha expirado 😔", color: "yellow darken-3" });
      this.$router.push("/login");
    }
    this.formatEventList();
    //await this.formatOrders2();
    this.loading=false;
  }
};
</script>
<style scoped>
@media (min-width: 1264px) {
  td {
    width: 50px;
  }
}
.table-header >>> thead {
  background-color: rgb(231, 231, 231);
}
</style>
